import { motion } from "framer-motion";
import { MessageCircle, LifeBuoy, Mail, Bug } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

const SupportSection = () => {
  const { t } = useI18n();

  const items = [
    {
      id: 'help',
      icon: LifeBuoy,
      title: t('support.item.help.title'),
      description: t('support.item.help.desc'),
      action: t('support.item.help.action'),
      path: '/support/help-center',
    },
    {
      id: 'discord',
      icon: MessageCircle,
      title: t('support.item.discord.title'),
      description: t('support.item.discord.desc'),
      action: t('support.item.discord.action'),
      path: '/support/discord',
    },
    {
      id: 'contact',
      icon: Mail,
      title: t('support.item.contact.title'),
      description: t('support.item.contact.desc'),
      action: t('support.item.contact.action'),
      path: '/support/contact',
    },
    {
      id: 'bug',
      icon: Bug,
      title: t('support.item.bug.title'),
      description: t('support.item.bug.desc'),
      action: t('support.item.bug.action'),
      path: '/support/report-bug',
    },
  ];

  return (
    <section id="support" className="py-20 px-6 relative">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="gradient-text">{t('support.titleAccent')}</span> {t('support.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('support.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass-card p-6 flex flex-col gap-4"
            >
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                <item.icon className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                <p className="text-sm text-muted-foreground">{item.description}</p>
              </div>
              <Link
                to={item.path}
                className="w-full"
              >
                <Button variant="outline" className="w-full">
                  {item.action}
                </Button>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SupportSection;
